import { DataService } from './dataService'


export const SubAdminService ={
    getSubAdminList: async () => {
        return DataService.get('/admin/employee/get_all')
    },
    getSubAdminById: async () => {
        return DataService.get('/admin/employee/get_by_id')
    },
    editSubAdmin: async (data) => {
        return DataService.put('/admin/employee/update', data)
    },
	addSubAdmin: async (data) => {
        return DataService.post('/admin/employee/create', data)
    },
	deleteSubAdmin: async (data) => {
        return DataService.delete('/admin/employee/delete', data)
    },    
}